/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import _t from 'i18n!nls/premium-certificate';

type ProductType = 'mastertrack' | 'universityCertificate' | 'professionalCertificate' | 'certificate';

type Props = {
  productType: ProductType;
};

const getTranslatedProductType = (productType: ProductType) => {
  switch (productType) {
    case 'mastertrack':
      return _t('MasterTrack');

    case 'universityCertificate':
      return _t('University Certificate');

    case 'professionalCertificate':
      return _t('Professional Certificate');

    case 'certificate':
    default:
      return _t('Certificate');
  }
};

const MtcUcert404 = ({ productType }: Props) => (
  <div data-testid="MtcUcert404">
    <div
      css={css`
        margin-top: 100px;
        margin-bottom: 100px;
      `}
      className="bt3-container"
    >
      <h1 className="headline-5-text">{_t('Sorry')}</h1>
      <p className="headline-2-text">
        {_t("We couldn't find the #{productType} that you're looking for.", {
          productType: getTranslatedProductType(productType),
        })}
        <span>&nbsp;</span>
        <a href="/browse">{_t('Browse catalog')}</a>
      </p>
    </div>
  </div>
);

export default MtcUcert404;
